module.exports = __webpack_public_path__ + "static/NO-streaming-video-gamiclub-tallyman.v1-pin/files/bced264488c6c3babd218320d4c67d23.png";